import { render } from "./TodoList.vue?vue&type=template&id=f209bb3e&ts=true"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__